import React, { createContext, useContext, useState, useEffect } from "react";
import { lsTheme } from "../constans/auth";

interface ThemeContextType {
  isDarkMode: boolean;
  toggleTheme: (checked: boolean) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem(lsTheme);
    return saved === "dark" || false;
  });

  const toggleTheme = (checked: boolean) => {
    setIsDarkMode(checked);
    localStorage.setItem(lsTheme, checked ? "dark" : "light");
  };

  useEffect(() => {
    if (isDarkMode) {
      document.body.style.backgroundColor = '#141414';
      document.documentElement.classList.add('dark-mode');
    } else {
      document.body.style.backgroundColor = '#f6f7f8'; // default layout background
      document.documentElement.classList.remove('dark-mode');
    }
  }, [isDarkMode]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useThemeContext must be used within a ThemeProvider");
  }
  return context;
};
